import { BASE_ORIENTATION } from '../constant';
import { createTwStyle, joinCn } from '../util';
import { TAB_ITEM_SIZE, TAB_ITEM_VARIANT } from './constant';
import type { TAB_ITEM_SIZE_KEY, TAB_ITEM_VARIANT_KEY } from './type';

type VTabStyleProps = {
  orientation?: BASE_ORIENTATION | Lowercase<BASE_ORIENTATION>;
  size?: TAB_ITEM_SIZE_KEY;
  variant?: TAB_ITEM_VARIANT_KEY;
  tabItemDisabled?: boolean;
  fluid?: boolean;
};

const twStyle = createTwStyle<VTabStyleProps>();

export default twStyle({
  tabList: ({
    fluid,
    orientation = BASE_ORIENTATION.HORIZONTAL,
    size = TAB_ITEM_SIZE.MD,
    variant = TAB_ITEM_VARIANT.PRIMARY,
  }) => [
    joinCn(
      'bg-gray-200 p-0.5',
      {
        'w-full': fluid,
        'w-fit': !fluid,
      },
      {
        'flex-row': orientation === BASE_ORIENTATION.HORIZONTAL,
        'flex-col': orientation === BASE_ORIENTATION.VERTICAL,
      },
      {
        'rounded-md':
          (size === TAB_ITEM_SIZE.LG ||
            size === TAB_ITEM_SIZE.LARGE ||
            size === TAB_ITEM_SIZE.MD ||
            size === TAB_ITEM_SIZE.MEDIUM) &&
          variant === TAB_ITEM_VARIANT.PRIMARY,
        'rounded-sm':
          (size === TAB_ITEM_SIZE.SM || size === TAB_ITEM_SIZE.SMALL) &&
          variant === TAB_ITEM_VARIANT.PRIMARY,
      },
      {
        'rounded-sm': variant === TAB_ITEM_VARIANT.SECONDARY,
      },
    ),
  ],
  tabItem: ({
    size = TAB_ITEM_SIZE.MD,
    variant = TAB_ITEM_VARIANT.PRIMARY,
  }) => [
    joinCn(
      {
        'rounded-md px-6 py-[5px] text-headline-sm':
          (size === TAB_ITEM_SIZE.LG || size === TAB_ITEM_SIZE.LARGE) &&
          variant === TAB_ITEM_VARIANT.PRIMARY,
        'rounded-md px-4 py-1.5 text-body-xl':
          (size === TAB_ITEM_SIZE.MD || size === TAB_ITEM_SIZE.MEDIUM) &&
          variant === TAB_ITEM_VARIANT.PRIMARY,
        'rounded-md px-4 py-0.5 text-body-lg':
          (size === TAB_ITEM_SIZE.SM || size === TAB_ITEM_SIZE.SMALL) &&
          variant === TAB_ITEM_VARIANT.PRIMARY,
      },
      {
        'rounded-sm px-4 py-0.5 text-body-lg':
          (size === TAB_ITEM_SIZE.MD || size === TAB_ITEM_SIZE.MEDIUM) &&
          variant === TAB_ITEM_VARIANT.SECONDARY,
        'rounded-sm px-4 py-0.5 text-body-md':
          (size === TAB_ITEM_SIZE.SM || size === TAB_ITEM_SIZE.SMALL) &&
          variant === TAB_ITEM_VARIANT.SECONDARY,
      },
      'flex items-center justify-center',
      'whitespace-nowrap',
      'overflow-hidden',
      'cursor-pointer',
      'bg-white text-primary-500',
      'aria-disabled:cursor-not-allowed! aria-disabled:bg-gray-200 aria-disabled:text-gray-300',
      'aria-checked:tracking-normal',
      {
        'aria-checked:bg-primary-500 aria-checked:font-bold aria-checked:text-white':
          variant === TAB_ITEM_VARIANT.PRIMARY,
        'aria-checked:font-bold aria-checked:text-secondary-300 aria-checked:shadow-border-secondary-300':
          variant === TAB_ITEM_VARIANT.SECONDARY,
      },

      [
        'hover:relative',
        'hover:after:absolute hover:after:top-0 hover:after:left-0',
        'hover:after:h-full hover:after:w-full',
        'hover:after:content-[""]',
        'hover:after:shadow-sm',
        'hover:after:z-1',
      ],

      ['aria-disabled:hover:after:content-none'],
    ),
  ],

  tabDivider: ({ orientation = BASE_ORIENTATION.HORIZONTAL }) => [
    joinCn(
      {
        'h-full w-px': orientation === BASE_ORIENTATION.HORIZONTAL,
        'h-px w-full': orientation === BASE_ORIENTATION.VERTICAL,
      },
      'rounded-sm',
      'bg-gray-300',
      'cursor-none',
    ),
  ],
});
